module.exports = __webpack_public_path__ + "static/media/mong2.122cb0ed.png";